<div
  class="history-view p-6 bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-900 min-h-screen"
  >
  <!-- Header -->
  <div class="mb-6">
    <h2 class="text-2xl font-bold text-gray-800 dark:text-gray-100">
      📊 Historique des ventes par service
    </h2>
  </div>

  <!-- Ventes groupées par service -->
  <div class="space-y-6">
    @for (group of serviceGroups; track group) {
      <div
        class="bg-white dark:bg-slate-800 rounded-xl shadow-lg dark:shadow-slate-900/50 overflow-hidden border-2 border-indigo-100"
        >
        <!-- En-tête du service (cliquable) -->
        <div
          (click)="toggleService(group.scheduledServiceId)"
          class="bg-gradient-to-r from-indigo-500 to-purple-600 text-white p-5 cursor-pointer hover:from-indigo-600 hover:to-purple-700 transition-all"
          >
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <span class="text-4xl">{{
                getServiceIcon(group.serviceName)
              }}</span>
              <div>
                <p class="text-indigo-100 text-sm">
                  Service du {{ formatDate(group.date) }} •
                  {{ group.startTime }} - {{ group.endTime }}
                </p>
                <h3 class="text-xl font-bold">{{ group.serviceName }}</h3>
              </div>
            </div>
            <div class="flex items-center gap-4">
              <div class="text-right">
                <div class="text-3xl font-bold">
                  {{ group.actualRevenue | number: "1.2-2" }}€
                </div>
                <div class="text-indigo-100 text-sm">
                  {{ group.salesCount }} vente(s)
                </div>
              </div>
              <div
                class="text-3xl transition-transform duration-300"
                [class.rotate-180]="isServiceExpanded(group.scheduledServiceId)"
                >
                ▼
              </div>
            </div>
          </div>
        </div>
        <!-- Statistiques du service -->
        @if (isServiceExpanded(group.scheduledServiceId)) {
          <div
            class="grid grid-cols-3 gap-4 p-5 bg-indigo-50 dark:bg-indigo-900/20 border-b-2 border-indigo-100"
            >
            <div class="text-center">
              <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">Revenu moyen / vente</div>
              <div class="text-xl font-bold text-indigo-600">
                {{ getAverageRevenue(group) | number: "1.2-2" }}€
              </div>
            </div>
            <div class="text-center">
              <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">Statut</div>
              <div
                class="text-xl font-bold"
                [class.text-green-600]="group.status === 'completed'"
                [class.text-blue-600]="group.status === 'active'"
                [class.text-gray-600]="group.status === 'planned'"
                >
                {{
                group.status === "completed"
                ? "✅ Terminé"
                : group.status === "active"
                ? "🟢 Actif"
                : "📅 Planifié"
                }}
              </div>
            </div>
            <div class="text-center">
              <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">Total produits vendus</div>
              <div class="text-xl font-bold text-purple-600">
                {{ getTotalProducts(group) }}
              </div>
            </div>
          </div>
        }
        <!-- Liste des ventes -->
        @if (isServiceExpanded(group.scheduledServiceId)) {
          <div class="p-5">
            <div class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
              Détail des ventes ({{ group.sales.length }})
            </div>
            <div class="space-y-3 max-h-96 overflow-y-auto">
              @for (sale of group.sales; track sale) {
                <div
                  class="bg-gray-50 dark:bg-slate-900 rounded-lg p-4 border border-gray-200 dark:border-slate-700 hover:border-indigo-300 transition-all"
                  >
                  <div class="flex justify-between items-start mb-2">
                    <div class="text-sm text-gray-600 dark:text-gray-400 flex items-center gap-2">
                      <span>{{ sale.timestamp | date: "HH:mm" }}</span>
                      <span
                        class="px-2 py-0.5 rounded text-xs font-medium"
                        [class.bg-blue-100]="sale.source === 'kiosk'"
                        [class.text-blue-700]="sale.source === 'kiosk'"
                        [class.bg-green-100]="sale.source === 'manual'"
                        [class.text-green-700]="sale.source === 'manual'"
                        >
                        {{ sale.source === "kiosk" ? "🖥️ Kiosk" : "✍️ Manuelle" }}
                      </span>
                      <span>• {{ sale.items.length }} produit(s)</span>
                    </div>
                    <div class="font-bold text-indigo-600">
                      {{ sale.totalAmount | number: "1.2-2" }}€
                    </div>
                  </div>
                  <div class="space-y-1">
                    @for (item of sale.items; track item) {
                      <div
                        class="text-sm text-gray-700 dark:text-gray-300 flex justify-between"
                        >
                        <span>{{ item.quantity }}x {{ item.productName }}</span>
                        <span class="font-medium"
                          >{{ item.totalPrice | number: "1.2-2" }}€</span
                          >
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }

      <!-- Message si aucun service -->
      @if (serviceGroups.length === 0) {
        <div
          class="text-center py-16 bg-white dark:bg-slate-800 rounded-xl shadow-lg dark:shadow-slate-900/50"
          >
          <div class="text-6xl mb-4">📭</div>
          <div class="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-2">
            Aucune vente enregistrée
          </div>
          <div class="text-gray-500 dark:text-gray-400">
            Les ventes apparaîtront ici une fois qu'elles seront effectuées
          </div>
        </div>
      }
    </div>
  </div>
